import { handleResponseError } from "./errorHandlingService";

export function deleteClientCompany(event, company, showMessage, refresh){
    event.preventDefault();

    company.deleteClientCompany(company)
        .then(response => {
            console.log(response)
            if (response.status === 200){
                showMessage(null, "Kunde wurde gelöscht", "success");
                refresh();
            }
        })
        .catch(err => {
            handleResponseError(err, [
                {
                    status: 404,
                    message: "Der Kunde existiert nicht."
                }
            ])
        });
}
